export enum ScheduleNotHappenedReasons {
  TOO_FAR_AWAY = "TOO_FAR_AWAY",
  CLIENT_WASNT_AT_HOME = "CLIENT_WASNT_AT_HOME",
  WITHOUT_MATERIALS = "WITHOUT_MATERIALS",
  OTHER = "OTHER",
}
